<vl-form-grid mod-stacked v-if="unaZone">
    <vl-column>
        <vl-title tag-name="h2">Contactgegevens</vl-title>
    </vl-column>
    <vl-column>
        <kl-contact-card :title="unaZone.contactName"
                         :phone="unaZone.contactTelephone"
                         :email="unaZone.contactEmail"
                         :message="unaZone.extraInformation"
                         :emergency-phone="unaZone.alarmCentralTelephone"
                         :emergency-email="unaZone.contactEmailEmergency"
                         mod-email-clickable />
    </vl-column>
</vl-form-grid>